import MUITableRow, {
  type TableRowProps as MUITableRowProps,
} from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import React from "react";
import { useRouter } from "next/navigation";

export type TableRowProps = MUITableRowProps & {
  href?: string;
};

const ClickableTableRow = styled(MUITableRow, {
  shouldForwardProp: (prop) => prop !== "clickable",
})<{ clickable?: boolean }>(({ theme, clickable }) => ({
  ...(clickable && {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  }),
}));

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ href, onClick, ...rest }, ref) => {
    const router = useRouter();

    if (href) {
      return (
        <ClickableTableRow
          ref={ref}
          clickable
          onClick={(e) => {
            if (onClick) onClick(e);
            router.push(href);
          }}
          {...rest}
        />
      );
    }

    return <MUITableRow ref={ref} onClick={onClick} {...rest} />;
  },
);

TableRow.displayName = "TableRow";
